var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('div',{staticClass:"mm",style:(_vm.backgroundStyle)}),_c('div',{staticClass:"banner-img"},[_c('img',{attrs:{"src":_vm.bannerSource,"alt":""}})]),_c('div',{staticClass:"banner-title"},[_c('p',[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }